var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"button",attrs:{"is-external":_vm.isExternal,"target":_vm.target,"link":_vm.link}},'component',_vm.$attrs,false),_vm.$listeners),[_c('span',{class:[
      _vm.icon || _vm.iconFile ? 'icon-and-slot-container' : '',
      { 'icon-last': _vm.iconLast }
    ],style:({
      visibility: _vm.isLoading ? 'hidden' : 'visible',
      flexDirection: _vm.iconLast ? 'row-reverse' : ''
    })},[(_vm.icon || _vm.iconFile)?_c('BaseIcon',{staticClass:"button-icon",attrs:{"icon":_vm.icon,"icon-file":_vm.iconFile,"rotate-deg":_vm.rotateDeg,"height":_vm.iconSize,"width":_vm.iconSize}}):_vm._e(),_vm._t("default")],2),(_vm.isLoading)?_c('div',{staticClass:"spinner-container"},[_c('BaseSpinner')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }